import Banner from '@sats-group/ui-lib/react/banner';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import React from 'react';
import { Logo } from '../logo/logo';
import { SplashLayout } from '../splash-layout/splash-layout';
import type { SimpleMessages as Props } from './simple-messages.page.types';

export const SimpleMessages: React.FC<Props> = ({
  actions,
  debug,
  messages,
}) => (
  <SplashLayout>
    <div className="simple-messages">
      <Logo elementName="h1" variant="light" />
      {debug ? (
        <code style={{ background: 'white', display: 'none' }}>
          <pre>{debug}</pre>
        </code>
      ) : null}
      {messages.map(entry => (
        <Banner {...entry} key={entry.text} />
      ))}
      <div className="simple-messages__actions">
        {actions.map((entry, index) => (
          <div key={entry.href}>
            <LinkButton
              {...entry}
              variant={
                index
                  ? LinkButton.variants.secondaryWhite
                  : LinkButton.variants.primaryWhite
              }
            />
          </div>
        ))}
      </div>
    </div>
  </SplashLayout>
);
